<script setup>
import {
  onMounted,
  onUnmounted,
  ref,
  watch,
  computed,
  defineExpose,
  defineEmits,
} from 'vue';
import {
  getData,
  searchAssetName,
  getChart,
  displayDetails,
} from './hybridView.js';
import { useElementSize, useStyleTag } from '@vueuse/core';
import { useRoute, useRouter } from 'vue-router/composables';
import moment from 'moment';
import { useMonitorStore } from '../monitor-view/monitor.js';

import { customCss } from '../table-view/quasar.js';
import MapView from './MapView.vue';
import TableView from '../table-view/TableView.vue';
import ModalView from '../map-view/ModalView.vue';
import ModalComp from '../table-view/ModalComp.vue';
import ToolBar from './ToolBar.vue';
import DetailsPanel from './DetailsPanel.vue';
import ShareLocation from '../table-view/ShareLocation.vue';

import { findNearbyState } from './findNearby.js';

const { id, css, load, unload } = useStyleTag(customCss, { id: 'naruto' });
onUnmounted(() => {
  unload();
});

const router = useRouter();
const route = useRoute();
const userInfo = JSON.parse(localStorage.getItem('userInfo'));
const { defaultView } = useMonitorStore();

const props = defineProps({
  data: {},
  isLegacy: { default: true },
  selectedUnits: {},
});

const emit = defineEmits(['loaded', 'selected', 'streetview']);

const ZOOM_LEVEL_FOR_SINGLE_UNIT = 12;

const data = ref([]);
// lap
const fetchObj = ref({
  lap: 0,
  time: 0,
  seconds: 60,
  timer: null,
});

onMounted(() => {
  if (props.isLegacy) {
    monitorRouteWatcher();
    fetchObj.value.lap++;
  } else {
    // stop legacy route watcher
    legacyHybridWatcher();
    emit('loaded');
    data.value = props.data;
    if (props.selectedUnits) {
      if (props.selectedUnits != selectedUnits.value) {
        selectedUnits.value = props.selectedUnits;
      }
    }
  }
});

watch(
  () => props.data,
  () => {
    if (props.data) {
      data.value = props.data;
    }
  },
);

const isLoadingMain = ref(false);
watch(
  () => fetchObj.value.lap,
  async () => {
    isLoadingMain.value = true;
    data.value = await getData({
      url: 'hybridUnitDetailsv2',
      fetchObj,
    });

    // console.log(data.value);
    isLoadingMain.value = false;
  },
);

// selectedUnits
const allUnits = JSON.parse(localStorage.getItem('allUnits'));
const selectedUnits = ref(allUnits);
watch(selectedUnits, (v) => {
  if (selectedUnitsProtocol.value) {
    //
  } else {
    if (!selectedUnits.value || selectedUnits.value.length == 0) {
      selectedUnits.value = allUnits;
    }
  }
  if (selectedUnits.value && selectedUnits.value.length == 1) {
    selectedUnit.value = selectedUnits.value[0];
  }
  if (map.value && selectedUnits.value.length > 1) {
    filterType.value = ['All'];
    map.value._setupState.fitBounds(selectedUnitsData.value);
  }
  // for monitor
  if (selectedUnits.value.length == allUnits.length) {
    emit('selected', null);
    selectedUnit.value = '';
    map.value._setupState.mapCenter();
  } else {
    emit('selected', selectedUnits.value);
  }
});
const selectedUnitsData = computed(() => {
  let arr = [];
  if (data.value) {
    if (selectedUnits.value) {
      arr = data.value.filter((e) => selectedUnits.value.includes(e.assetId));
    }
  }
  return arr;
});
// watch(selectedUnits, () => {
//   if (selectedUnitsData.value) {
//     filterType.value = ['All'];
//   }
// });

function assetsSelect(v) {
  selectedUnits.value = v;
}
function setTrafficLayer(v) {
  showTrafficLayer.value = v;
}
// filterType
const filterType = ref(['All']);
function filtering(v) {
  filterType.value = v;
  setTimeout(() => {
    // let markers = filterTypeData.value.map((e) => {
    //   return {
    //     position: {
    //       lat: e.lat,
    //       lng: e.lng,
    //     },
    //   };
    // });

    if (map.value) {
      map.value._setupState.fitBounds(filterTypeData.value);
    }
  }, 10);
}
const statusList = {
  Moving: 'Move',
  Idling: 'Idle',
  Parked: 'Park',
  Inactive: 'Inactive',
};
const filterTypeData = computed(() => {
  let filter = filterType.value[0];
  if (filter == 'All') {
    return selectedUnitsData.value;
  } else {
    return selectedUnitsData.value.filter((e) => {
      return statusList[e.status] == filter ? e : void 0;
    });
  }
});
const stat = computed(() => {
  const stat = [0, 0, 0, 0];
  const list = {
    Moving: 0,
    Idling: 1,
    Parked: 2,
    Inactive: 3,
  };
  selectedUnitsData.value.forEach((e) => {
    stat[list[e.status]] += 1;
  });
  return stat;
});
// search
const search = ref('');
// filteredData
const filteredData = computed(() => {
  if (search.value.trim() != '') {
    return searchAssetName(filterTypeData.value, search.value);
  } else {
    return filterTypeData.value;
  }
});

// manual ui control
const renderMap = ref(false);
const isMap = ref(false);
const isTable = ref(false);
const maldivesPolyline = ref(null);
const center = ref({ lat: 3.910187, lng: 102.119262 });
const initialZoom = ref(8);

watch(filteredData, () => {
  if (data.value) {
    setTimeout(() => {
      renderMap.value = true;
    }, 200);
  }
  // console.log(filterTypeData.value);
});

// ui
const container = ref();
const { width, height } = useElementSize(container);

const uiConfig = ref({
  openDetailsOnSelected: true,
});

const toolBarOptions = ref({
  search: true,
  filter: true,
  poi: true,
  traffic: true,
});
const selectedUnitsProtocol = ref(0);

const legacyHybridWatcher = watch(route, () => {
  selectedUnitsProtocol.value = 0;
  selectedUnits.value = null;
  filterType.value = ['All'];
  search.value = '';
  selectedUnit.value = '';
  selectedUnitDetails.value = null;
  detailsPanel.value = false;
  setTimeout(() => {
    mountHybrid();
    mountMap();
    mountTable();
    if (map.value) {
      map.value._setupState.mapCenter();
    }
  }, 10);
});
onMounted(() => {
  if (
    userInfo.username == 'maldives' ||
    userInfo.username == 'igtmaldives' ||
    userInfo.username == 'igeotech' ||
    userInfo.username == 'pmluser'
  ) {
    if (
      userInfo.username == 'maldives' ||
      userInfo.username == 'igtmaldives' ||
      userInfo.username == 'pmluser'
    ) {
      center.value = { lat: 3.2028, lng: 73.2207 };
      initialZoom.value = 6.3;
    }
  }

  // console.log(route);
  if (!props.isLegacy) return;

  mountHybrid();
  mountMap();
  mountTable();
});
function mountHybrid() {
  splitterModel.value = (height.value / 3) * 2;
  uiConfig.value = { openDetailsOnSelected: false };
}
function mountMap() {
  const arr = ['hybrid', 'map', 'experimental'];
  if (
    arr.includes(route.name) ||
    (route.params.view && arr.includes(route.params.view))
  ) {
    isMap.value = true;
    toolBarOptions.value.traffic = true;
  } else {
    isMap.value = false;
  }
  if (
    route.name == 'map' ||
    (route.params.view && route.params.view == 'map')
  ) {
    uiConfig.value = { openDetailsOnSelected: true };
    selectedUnitsProtocol.value = 1;
    splitterModel.value = height.value;
    toolBarOptions.value.traffic = true;
    if (route.params.assetName && route.params.assetId) {
      selectedUnits.value = [Number(route.params.assetId)];
      selectedUnit.value = selectedUnits.value[0];
    } else {
      selectedUnits.value = [];
    }
  }
}
function mountTable() {
  const arr = ['hybrid', 'table', 'experimental'];
  if (
    arr.includes(route.name) ||
    (route.params.view && arr.includes(route.params.view))
  ) {
    isTable.value = true;
  } else {
    isTable.value = false;
  }
  if (
    route.name == 'table' ||
    (route.params.view && route.params.view == 'table')
  ) {
    splitterModel.value = 56;
    toolBarOptions.value.poi = false;
    toolBarOptions.value.traffic = false;
  } else {
    toolBarOptions.value.poi = true;
  }
}

const splitterModel = ref(0);

const detailsPanel = ref(false);

const columns = [
  { name: 'assetName', label: 'Asset', style: 'width:12%' },
  { name: 'lastUpdated', label: 'Time', style: 'width:5%' },
  { name: 'Ignition', style: 'width:5%' },
  { name: 'Volt' },
  { name: 'Batt', label: 'Batt' },
  { name: 'idlingStatus', label: 'Idling', style: 'width:5%' },
  { name: 'Speed', style: 'width:5%' },
  { name: 'BP', label: 'BP' },
  { name: 'HR', label: 'HR' },
  { name: 'SPO2', label: 'SPO2' },
  { name: 'Steps', label: 'Steps' },
  { name: 'mileage', label: 'Odometer', style: 'width:5%' },
  { name: 'Fuel', align: 'center' },
  { name: 'Temp' },
  { name: 'Humidity' },
  { name: 'gps', label: 'GPS' },
  { name: 'input', label: 'Input' },
  { name: 'output', label: 'Output' },
  { name: 'video', label: 'Video' },
  { name: 'address', label: 'Location' },
  { name: 'Beacon', label: 'Beacon' },
  { name: 'Status', align: 'center' },
];
const visibleColumns = computed(() => {
  if (
    userInfo.username == 'mhbadmin' ||
    userInfo.username == 'ironwatch' ||
    userInfo.username == 'demowatch'
  ) {
    const propsCheck = [];
    const valueCheck = ['-', '-', '-', '-'];

    const visible = columns.map((e) =>
      !e.label ? e.name.toLowerCase() : e.name,
    );
    const empty = propsCheck.filter((prop, i) =>
      filteredData.value.every((obj) => obj[prop] === valueCheck[i]),
    );

    const filteredColumns = columns.filter(
      (e) =>
        visible.includes(!e.label ? e.name.toLowerCase() : e.name) &&
        !empty.includes(!e.label ? e.name.toLowerCase() : e.name),
    );
    const result = filteredColumns.map((e) => e.name);

    return result;
  } else {
    const propsCheck = [
      'idlingStatus',
      'fuel',
      'temp',
      'input',
      'output',
      'volt',
      'humidity',
      'video',
    ];
    const valueCheck = ['-', '-', '-', '-', '-', '-', '-', '-'];

    const visible = columns.map((e) =>
      !e.label ? e.name.toLowerCase() : e.name,
    );
    const empty = propsCheck.filter((prop, i) =>
      filteredData.value.every((obj) => obj[prop] === valueCheck[i]),
    );

    const filteredColumns = columns.filter(
      (e) =>
        visible.includes(!e.label ? e.name.toLowerCase() : e.name) &&
        !empty.includes(!e.label ? e.name.toLowerCase() : e.name),
    );
    const result = filteredColumns.map((e) => e.name);
    return result;
  }
});

// selected
const selectedUnit = ref('');
function selected(props) {
  selectedUnit.value = props.assetId;
}
const selectedUnitDetails = ref(null);
const heatmap = ref(null);
const showHeatmap = ref(false);
const showTrafficLayer = ref(false);
const detailsLoading = ref(false);
watch(selectedUnit, async () => {
  if (selectedUnit.value != '') {
    detailsLoading.value = true;
    detailsPanel.value = uiConfig.value.openDetailsOnSelected;
    const [selectedUnitDetailsData, heatmapData] = await displayDetails(
      selectedUnit.value,
    );
    selectedUnitDetails.value = selectedUnitDetailsData;
    heatmap.value = heatmapData;
    showHeatmap.value = false;
    detailsLoading.value = false;
  }
  // console.log(selectedUnit.value, map.value.zoom);
  if (map.value && map.value.zoom < ZOOM_LEVEL_FOR_SINGLE_UNIT) {
    map.value.zoom = ZOOM_LEVEL_FOR_SINGLE_UNIT;
  }
});

watch(data, async () => {
  if (selectedUnit.value != '') {
    detailsLoading.value = true;
    detailsPanel.value = uiConfig.value.openDetailsOnSelected;
    const [selectedUnitDetailsData, heatmapData] = await displayDetails(
      selectedUnit.value,
    );
    selectedUnitDetails.value = selectedUnitDetailsData;
    heatmap.value = heatmapData;
    showHeatmap.value = false;
    detailsLoading.value = false;
  }
});

const map = ref();

function getUnit() {
  filterType.value = ['All'];
  setTimeout(() => {
    map.value._setupState.getUnit(selectedUnit.value);
  }, 100);
}

// modal
async function openChart(v) {
  const { data, dataSchema, dataSource } = await getChart(v);
  let onReady = async (self) => {
    return new Promise((resolve) => {
      self.dataSource = self.data.data.dataSource;
      self.onReadyData.title = self.dataSource.chart.exportFileName;
      resolve({ data, dataSchema });
    });
  };
  let obj = {};
  obj.data = {};
  obj.data.onReady = onReady;
  obj.data.dataSource = dataSource;
  modalData.value.data = obj;
  modalData.value.component = 'FuelChart';
  isModalOpen.value = true;
}

const isModalOpen = ref(false);
const modalData = ref({ component: '', data: null });

const shareLocation = ref(false);
const shareLocationData = ref();

const excelData = computed(() => {
  let v = [
    {
      fileName: '',
      header: [],
      data: [],
      fields: [],
      labels: [],
      colsWidth: [],
      filter: filterType.value,
    },
  ];
  let colsWidth = [100, 100, 50, 40, 40, 50, 60, 40, 40, 50, 120, 50];
  if (data.value.length > 0) {
    let obj = v[0];
    let time = moment().format('D/M/YYYY | HH:mm:ss');
    obj.fileName = `Vehicle List ${filterType.value} ${time}`;
    obj.header = [
      [`Report Type : Vehicle List`],
      [`Filter : ${filterType.value}`],
      [`Time            :  ${time}`],
      [],
    ];
    obj.data = filteredData.value;
    visibleColumns.value.forEach((e) => {
      columns.forEach((col, i) => {
        if (e == col.name) {
          if (!col.label) {
            obj.labels.push(col.name);
            obj.fields.push(col.name.toLowerCase());
          } else {
            obj.labels.push(col.label);
            obj.fields.push(col.name);
          }
          obj.colsWidth.push(colsWidth[i]);
        }
      });
    });
  }
  return v[0];
});

// monitor
const monitorRouteWatcher = watch(
  () => route.params.view,
  async (n, o) => {
    // if (props.isLegacy) return;
    if (route.params.view) {
      if (props.isLegacy) return;
      let view = route.params.view;
      setTimeout(async () => {
        initMonitor();
      }, 0);
      setTimeout(async () => {
        if (view == 'hybrid') {
          isMap.value = true;
          isTable.value = true;
          await mountHybridMonitor();
        }
        if (view == 'map') {
          await mountMapMonitor();
        }
        if (view == 'table') {
          await mountTableMonitor();
        }
        if (view == 'multi') {
          await mountMapMonitor();
        }
      }, 10);
    } else {
      if (route.name != 'monitor') return;
      if (!o) {
        router.push({ name: 'monitor', params: { view: defaultView.value } });
      } else {
        router.push({ name: 'monitor', params: { view: o } });
      }
    }
    // console.log(n, o);
  },
  { immediate: true, deep: true },
);

const isSplitterAnimating = ref(false);

async function mountHybridMonitor() {
  uiConfig.value = { openDetailsOnSelected: false };
  if (!hybridSplitter.value) {
    isSplitterAnimating.value = true;
    await animateNumber(splitterModel.value, (height.value / 3) * 2, duration);
    isSplitterAnimating.value = false;
  } else {
    hybridSplitter.value = false;
  }
}
async function mountMapMonitor() {
  uiConfig.value = { openDetailsOnSelected: true };
  isSplitterAnimating.value = true;
  await animateNumber(splitterModel.value, height.value, duration);
  isSplitterAnimating.value = false;
  isTable.value = false;
  if (map.value && map.value.zoom < ZOOM_LEVEL_FOR_SINGLE_UNIT) {
    map.value.zoom = ZOOM_LEVEL_FOR_SINGLE_UNIT;
  }
}
async function mountTableMonitor() {
  toolBarOptions.value.poi = false;
  toolBarOptions.value.traffic = false;
  isSplitterAnimating.value = true;
  await animateNumber(splitterModel.value, 56, duration);
  isSplitterAnimating.value = false;
  isMap.value = false;
}
function initMonitor() {
  isMap.value = true;
  isTable.value = true;
  // splitterModel.value = 0;

  uiConfig.value = { openDetailsOnSelected: false };
  toolBarOptions.value.poi = true;
  toolBarOptions.value.traffic = true;
}

const duration = 170;

function animateNumber(from, to, time) {
  return new Promise((resolve) => {
    let startTime;

    function updateNumber(timestamp) {
      if (!startTime) {
        startTime = timestamp;
      }

      const progress = Math.min(1, (timestamp - startTime) / time);
      const newValue = Math.round(from - progress * (from - to));

      splitterModel.value = newValue;

      if (progress < 1) {
        requestAnimationFrame(updateNumber);
      } else {
        resolve(); // Resolve the promise when the animation is complete
      }
    }

    requestAnimationFrame(updateNumber);
  });
}

const hybridSplitter = ref(false);
const disableDrag = ref(false);
watch(splitterModel, () => {
  if (props.isLegacy) return;
  if (isSplitterAnimating.value) return;
  splitterMode();
});

function splitterMode() {
  if (route.params.view) {
    let view = route.params.view;
    if (view == 'table') {
      if (splitterModel.value >= 56 + 100) {
        hybridSplitter.value = true;
        router.push({ name: 'monitor', params: { view: 'hybrid' } });
      }
    }

    if (view == 'map') {
      if (splitterModel.value <= height.value - 100) {
        hybridSplitter.value = true;
        router.push({ name: 'monitor', params: { view: 'hybrid' } });
      }
    }
    if (view == 'hybrid') {
      if (splitterModel.value >= height.value - 80) {
        disableDrag.value = true;
        splitterModel.value = height.value;
        router.push({ name: 'monitor', params: { view: 'map' } });
        setTimeout(() => {
          disableDrag.value = false;
        }, 100);
      }

      if (splitterModel.value <= 56 + 80) {
        disableDrag.value = true;
        splitterModel.value = 56;
        router.push({ name: 'monitor', params: { view: 'table' } });
        setTimeout(() => {
          disableDrag.value = false;
        }, 100);
      }
    }
  }
}

async function manualSetSplitter() {
  if (route.params.view) {
    let view = route.params.view;
    if (view == 'table') {
      await mountTableMonitor();
    }
    if (view == 'map') {
      await mountMapMonitor();
    }
    if (view == 'hybrid') {
      await mountHybridMonitor();
    }
  }
}

const streetview = ref(false);

watch(streetview, (v) => {
  emit('streetview', v);
});
watch(map, (v) => {
  if (v) {
    map.value.mapRef.$mapPromise.then((mapObj) => {
      let thePanorama = mapObj.getStreetView();

      google.maps.event.addListener(
        thePanorama,
        'visible_changed',
        function () {
          if (thePanorama.getVisible()) {
            streetview.value = true;
            // Display your street view visible UI
          } else {
            streetview.value = false;
            // Display your original UI
          }
        },
      );
    });
  }
});

const nearby = ref([]);
const toolBar = ref();

function findNearby() {
  // return;
  // toolBar.value.manualClear();
  // console.log(toolBar.value);
  selectedUnits.value = [];

  const selectedUnitObj = data.value.find(
    (e) => e.assetId == selectedUnit.value,
  );
  const nearestObjects = findNearest(data.value, selectedUnitObj, 5);
  // selectedUnits.value.push(...nearestObjects.map((e) => e.assetId));
  nearestObjects.forEach((e) => {
    e.distance = e.distance.toFixed(2);
  });

  selectedUnits.value = [
    selectedUnit.value,
    ...nearestObjects.map((e) => e.assetId),
  ];
  findNearbyState.value = [selectedUnitObj, ...nearestObjects];
}
function haversine(lat1, lng1, lat2, lng2) {
  const toRadians = (degree) => degree * (Math.PI / 180);
  const R = 6371; // Earth's radius in kilometers

  const dLat = toRadians(lat2 - lat1);
  const dLng = toRadians(lng2 - lng1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
      Math.cos(toRadians(lat2)) *
      Math.sin(dLng / 2) *
      Math.sin(dLng / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c; // Distance in kilometers
}
function findNearest(objects, selectedObject, count = 5) {
  const { lat: selLat, lng: selLng } = selectedObject;

  // Calculate distances and sort
  const sortedByDistance = objects
    .filter((obj) => obj.unitId !== selectedObject.unitId) // Exclude the selected object
    .map((obj) => ({
      ...obj,
      distance: haversine(selLat, selLng, obj.lat, obj.lng),
    }))
    .sort((a, b) => a.distance - b.distance);

  // Return the top `count` nearest objects
  return sortedByDistance.slice(0, count);
}
</script>
<template>
  <div class="fit flex flex-row relative" ref="container">
    <div
      class="relative duration-200"
      :style="{ width: `${width - (detailsPanel && isMap ? 405 : 0)}px` }"
    >
      <tool-bar
        v-if="!streetview"
        ref="toolBar"
        :data="data"
        :visible-columns="visibleColumns"
        :columns="columns"
        :stat="stat"
        :filterType="filterType"
        :excelData="excelData"
        :isLegacy="isLegacy"
        :initialSelect="props.selectedUnits"
        @exportPdf="
          (v) => {
            modalData.data = v;
            modalData.component = 'ReportsPdfExport';
            isModalOpen = true;
          }
        "
        @search="
          (v) => {
            search = v;
          }
        "
        :isLoadingMain="isLoadingMain"
        :options="toolBarOptions"
        @filtering="filtering"
        @selected="assetsSelect"
        @setTrafficLayer="setTrafficLayer"
      >
        <template #export-left>
          <q-btn
            v-if="selectedUnit"
            :color="'primary'"
            :icon="'radar'"
            size="sm"
            padding="sm sm"
            @click="findNearby"
          >
            <q-tooltip content-class="bg-primary"> Find Nearby </q-tooltip>

            <q-menu context-menu>
              <q-virtual-scroll
                style="max-height: 370px; min-width: 100px"
                :items="findNearbyState"
                separator
                v-slot="{ item, index }"
              >
                <q-item
                  clickable
                  v-close-popup
                  :key="index"
                  dense
                  class="px-4 relative overflow-hidden"
                  :class="[
                    { 'bg-blue-1': selectedUnit == item.assetId },
                    { 'bg-primary text-white': !index },
                  ]"
                  @click="selectedUnit = item.assetId"
                >
                  <div
                    class="h-full absolute left-0 top-0"
                    style="width: 4px"
                    :style="{ background: item.color }"
                  />
                  <q-item-section>
                    <span class="flex w-full justify-between">
                      <span>
                        {{ item.assetName }}
                      </span>
                      <span v-if="index"> - {{ item.distance }}KM </span>
                    </span>
                  </q-item-section>
                </q-item>
                <q-item
                  v-if="index == findNearbyState.length - 1"
                  clickable
                  v-close-popup
                  @click="
                    selectedUnits = allUnits;
                    findNearbyState = [];
                    selectedUnit = '';
                  "
                >
                  <q-item-section class="px-4"
                    >Clear Find Nearby
                  </q-item-section>
                </q-item>
              </q-virtual-scroll>
              <!-- </q-list> -->
            </q-menu>
          </q-btn>
        </template>
      </tool-bar>
      <q-splitter
        class="fit"
        :disable="
          !$route.name == 'hybrid' ||
          ($route.name == 'monitor' &&
            isLegacy &&
            $route.params.view !== 'hybrid') ||
          ($route.query.c && $route.query.c !== 'HybridView') ||
          disableDrag
        "
        v-if="splitterModel"
        ref="splitter"
        unit="px"
        :limits="[56, Infinity]"
        v-model="splitterModel"
        horizontal
        emit-immediately
        after-class="p-0 flex"
        separator-class="bg-grey-3"
      >
        <template v-slot:before>
          <map-view
            v-if="renderMap && isMap"
            class="fit"
            :class="{ naruto: $route.name == 'monitor' }"
            :data="filteredData"
            :center="center"
            :initialZoom="initialZoom"
            :selectedUnit="selectedUnit"
            :heatmap="heatmap"
            :showHeatmap="showHeatmap"
            :showTrafficLayer="showTrafficLayer"
            @selected="selected"
            ref="map"
            :maldivesPolyline="maldivesPolyline"
          />
        </template>
        <template v-slot:separator>
          <q-chip
            v-if="
              $route.name == 'hybrid' ||
              ($route.name == 'monitor' &&
                isLegacy &&
                $route.params.view == 'hybrid') ||
              ($route.name == 'monitor' && !isLegacy) ||
              ($route.query.c && $route.query.c == 'HybridView')
            "
            :dense="splitterModel >= height - 30 ? false : true"
            class="flex bg-primary text-white duration-150"
            :style="{
              transform: `translateY(${
                splitterModel >= height - 5 ? '-28px' : '-50%'
              }) translateX(-50%)`,
            }"
          >
            <q-icon name="drag_indicator" />
          </q-chip>
        </template>
        <template v-slot:after>
          <TableView
            v-if="filteredData && isTable"
            class="flex-1 pt-0"
            :style="{
              height: `${height - splitterModel}px`,
            }"
            :data="filteredData"
            :scroll-size-item="5"
            :selectedUnit="selectedUnit"
            :visibleColumns="visibleColumns"
            @selected="selected"
            @chart="openChart"
            @map="
              (row) => {
                modalData.data = `${row.lat},${row.lng}`;
                modalData.component = 'GoogleMapEmbed';
                isModalOpen = true;
              }
            "
            @share-location="
              (row) => {
                shareLocationData = row;
                shareLocation = true;
              }
            "
          />
        </template>
      </q-splitter>
      <div v-else class="fit flex flex-center flex-col">
        Something went wrong! Please reload with the button below
        <q-btn color="primary" label="Reset" @click="manualSetSplitter" />
      </div>
    </div>
    <!-- details panel -->
    <div
      class="h-full bg-white flex rounded-l relative"
      style="
        transition: 0.2s;
        box-shadow: -5px 2px 5px rgba(0, 0, 0, 0.178);
        z-index: 2;
      "
      :style="{ width: `${detailsPanel && isMap ? '400px' : '0px'}` }"
      v-if="isMap"
    >
      <DetailsPanel
        :data="selectedUnitDetails"
        :showHeatmapProp="showHeatmap"
        :detailsLoading="detailsLoading"
        @show-heatmap="
          (v) => {
            showHeatmap = v;
          }
        "
        @chart="openChart"
        @get-unit="getUnit"
      />
      <div
        @click="detailsPanel = !detailsPanel"
        :aria-label="detailsPanel ? 'Collapse Panel' : 'Expand Panel'"
        class="absolute panel-button flex flex-center"
        style="box-shadow: -2px 2px 5px rgba(0, 0, 0, 0.466)"
      >
        <img
          :style="{ transform: `scale(${detailsPanel ? -1 : 1})` }"
          src="//maps.gstatic.com/tactile/pane/arrow_left_1x.png"
        />
        <q-tooltip content-class="bg-black">
          {{ detailsPanel ? 'Collapse Panel' : 'Expand Panel' }}
        </q-tooltip>
      </div>
    </div>
    <!-- modal -->
    <Transition name="scale">
      <modal-comp
        v-if="isModalOpen"
        @close="isModalOpen = false"
        :data="modalData.data"
        :component="modalData.component"
      />
    </Transition>
    <!-- modal -->
    <Transition name="scale">
      <share-location
        v-if="shareLocation"
        @close-modal="shareLocation = false"
        :data="shareLocationData"
      />
    </Transition>
  </div>
</template>

<style scoped>
.panel-button {
  transform: translate(-100%, -50%);
  top: 50%;
  white-space: normal;
  font: inherit;
  list-style: none;
  margin: 0;
  outline: 0;
  overflow: visible;
  padding: 0;
  vertical-align: baseline;
  color: inherit;
  border: 0;
  box-shadow:
    0 1px 2px rgba(60, 64, 67, 0.3),
    0 2px 6px 2px rgba(60, 64, 67, 0.15);
  width: 23px;
  height: 48px;
  cursor: pointer;
  border-left: 1px solid #dadce0;
  background: #fff 7px center/7px 10px no-repeat;
  background-color: #fff;
  border-radius: 8px 0 0 8px;
}
</style>
<style>
.naruto .gmnoprint.gm-style-mtc-bbw {
  transform: translateY(56px) scale(0.83) !important;
  transform-origin: top left;
}
</style>
